import coreHelper from "@/utils/coreHelper";
import apiService from "./apiService";

const paymentService = {
    async initiateWBPayment(payload) {
        try {
            const resp = await apiService.post(`payments/initiate-wb-payment`, payload, true);
            return resp.data;
        } catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async initiateRPTPayment(payload){
        try {
            const resp = await apiService.post(`payments/initiate-rpt-payment`, payload, true);
            return resp.data;
        } catch {
            return coreHelper.createGenericResponseError();
        }
    },
    async initiateBPLSPayment(payload) {
        try {
            const resp = await apiService.post(`payments/initiate-bpls-payment`, payload, true);
            return resp.data;
        } catch {
            return coreHelper.createGenericResponseError();
        }
    },
}

export default paymentService;